import { useEffect, useState } from 'react';
import { useInterval } from 'react-use';
import { ThumbnailImageMetadata } from '../types';
import { getThumbnailFrameCount } from '../utils';

/** Full carousel duration; step interval is derived from frame count. */
const ANIMATION_DURATION_MS = 10_000;

/** Avoid thrashing the UI when a sheet has many frames. */
const MIN_FRAME_INTERVAL_MS = 100;

/**
 * Cycles through every sprite frame (row-major) for animated thumbnail previews.
 * Replaces the legacy CSS steps() animation that only walked the first row.
 */
export function useCyclingThumbnailFrame(metadata: ThumbnailImageMetadata): number {
  const frameCount = getThumbnailFrameCount(metadata);
  const [frameIndex, setFrameIndex] = useState(0);

  useEffect(() => {
    setFrameIndex(0);
  }, [metadata.columns, metadata.rows, metadata.width, metadata.height]);

  const frameIntervalMs =
    frameCount <= 1
      ? null
      : Math.max(MIN_FRAME_INTERVAL_MS, Math.floor(ANIMATION_DURATION_MS / frameCount));

  useInterval(() => {
    setFrameIndex((prev) => (prev + 1) % frameCount);
  }, frameIntervalMs);

  return frameIndex;
}
